
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 11","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.031 4.625c.117 0 .235.059.332.137a.554.554 0 01.137.332V9.78a.471.471 0 01-.137.332.458.458 0 01-.332.137H.47c-.137 0-.254-.04-.332-.137C.039 10.035 0 9.918 0 9.781V5.094a.471.471 0 01.469-.469H2.03zM1.25 9.469A.471.471 0 001.719 9a.554.554 0 00-.137-.332.554.554 0 00-.332-.137.471.471 0 00-.332.137A.457.457 0 00.781 9c0 .137.04.254.137.332.078.098.195.137.332.137zM7.5 1.832c0-.625-.176-1.055-.527-1.328a1.557 1.557 0 00-.88-.254c-.175 0-.331.156-.448.43-.079.156-.137.39-.215.683v.02c-.078.293-.137.508-.176.625-.078.234-.195.41-.313.527-.214.195-.468.527-.78.977-.391.547-.704.957-.958 1.23a.178.178 0 00-.078.156v4.18c0 .078.02.137.059.176.039.039.097.059.175.059.215 0 .547.117.996.312.45.195.801.332 1.075.41.43.156.86.215 1.289.215h.058c.567 0 .996-.02 1.27-.078.45-.078.762-.235.937-.488.157-.235.215-.528.137-.88.156-.175.254-.41.332-.683a1.51 1.51 0 00-.02-.781 1.64 1.64 0 00.294-.762 1.86 1.86 0 00-.118-.8h.02c.098-.118.176-.255.254-.43.078-.157.117-.332.117-.528 0-.293-.117-.547-.352-.78a1.124 1.124 0 00-.82-.353H6.855c.02-.117.098-.332.254-.605.118-.234.215-.41.274-.547.078-.234.117-.469.117-.703z"}})])
          )
        }
      }
    